import React from "react";
import ReactDOM from "react-dom";
import { ToastContainer } from "react-toastify";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { NextUIProvider } from "@nextui-org/react";
// import { Provider } from "react-redux";
// import LogRocket from "logrocket";
// Import FilePond styles
import "filepond/dist/filepond.min.css";
import "react-toastify/dist/ReactToastify.css";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import "./index.css";
// Translations
import "./i18n";
// Chart.js
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store, persistor } from "./redux/store";
import { LanguageProvider } from "./contexts/LanguageContext";

// Firebase
import { refreshToken } from "./conf/firebase";
import getConfig from "./conf/config";

const config = getConfig();
// if (config.logRocket) {
//   console.log("log 🚀");
//   LogRocket.init(config.logRocket);
// }

// refreshToken();

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  // Required by the gradient area fill shared by every line chart.
  Filler
);

// Sentry.init({
//   dsn: "https://b75987404f2cb08899ea47e6f1eaef2a@o4507866364706816.ingest.de.sentry.io/4508212024442960",
//   integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

const EasierLab = () => {
  return (
    <BrowserRouter>
      <NextUIProvider>
        <ToastContainer />
        <Provider store={store}>
          <PersistGate persistor={persistor}>
            <LanguageProvider>
              <App />
            </LanguageProvider>
          </PersistGate>
        </Provider>
      </NextUIProvider>
    </BrowserRouter>
  );
};

// ReactDOM.render(
//   <React.StrictMode>
//     <EasierLab />
//   </React.StrictMode>,
//   document.getElementById("root")
// );

// 👇️ IMPORTANT: use correct ID of your root element
// this is the ID of the div in your index.html file
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <EasierLab />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
